import React from "react";
import styled from "styled-components";
import PaymentIcon from "react-payment-icons-inline";
import {Pencil} from "styled-icons/heroicons-outline/Pencil";
import {useDataSource} from "src/core/data-sources/decorators/withData";
import useRouter from "src/core/common/hooks/useRouter";
import {
  ModalActionContainer,
  ModalSectionButton,
  ModalText,
  ModalTitle,
  ModalSubText,
} from "src/core/common/components/modules/modal/modalComponents";
import MonerisPaymentSourcesDataSource from "src/core/payments/moneris/monerisPaymentSourcesDataSource";
import PaymentSource from "src/core/payments/PaymentSource";
import {cardTypes} from "src/core/payments/CardComponents/cardTypes";
import monerisIcon from "src/core/common/assets/moneris.png";

export default function Moneris({editCardRoute}) {
  const router = useRouter();

  const monerisPaymentSourcesDataSource = new MonerisPaymentSourcesDataSource();
  const {monerisPaymentSources} = useDataSource(
    {},
    {
      dataSource: monerisPaymentSourcesDataSource,
      keyFields: [""],
      dataField: "monerisPaymentSources",
    }
  );
  const defaultMonerisPaymentMethod =
    monerisPaymentSources && monerisPaymentSources.find((pSource) => pSource.isDefault);

  const MonerisIcon = () => (
    <img alt="moneris-icon" src={monerisIcon} style={{height: "18px"}} />
  );

  return (
    <>
      <ModalTitle>Cards</ModalTitle>
      <ModalSectionButton
        data-cy="defaultCardPaymentListButton"
        onClick={() =>
          router.push({pathname: editCardRoute, params: {creditCardType: "moneris"}})
        }
      >
        <ModalText>
          {defaultMonerisPaymentMethod ? (
            <ProviderContainer>
              <PaymentSource
                readOnly={true}
                isExpired={defaultMonerisPaymentMethod.isExpired}
                institution={null}
                institutionName={defaultMonerisPaymentMethod.getMaskLabel()}
                label={defaultMonerisPaymentMethod.getExpiryLabel()}
                paymentDate={null}
                icon={
                  <PaymentIcon
                    icon={cardTypes[defaultMonerisPaymentMethod.institution]}
                    style={{width: 40, height: 25}}
                  />
                }
              />
            </ProviderContainer>
          ) : (
            "Set default payment card..."
          )}
        </ModalText>
        <ModalActionContainer>
          <PencilIcon />
        </ModalActionContainer>
      </ModalSectionButton>
      <ModalSubText>
        <MonerisIcon />
        Powered by Moneris
      </ModalSubText>
    </>
  );
}

const ProviderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const PencilIcon = styled(Pencil)`
  height: 20px;
  width: 20px;
  color: black;
`;
